import { useState, useCallback, useEffect } from "react";
import DataTable from "../DataTable/dataTable";
import { useDispatch } from "react-redux";
import { setObjectDetails } from "../../redux/reducers/objectSlice";
import { debounce, getFromStorage } from "../../utils/helpers";
import { LocalStorageKeys } from "../../utils/constant";
import { useNavigate } from "react-router-dom";

function SaveTable() {
  const navigate = useNavigate();
  const [columnDefination, setColumnDefination] = useState([
    { Header: "Name", accessor: "tableName" },
    { Header: "Created Date", accessor: "createdAt" },
    { Header: "Last Modified Date", accessor: "updatedAt" },
  ]);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [selectedData, setselectedData] = useState(null);
  const dispatch = useDispatch();

  // Fetch data  on component mount
  useEffect(() => {
    const fetchData = async () => {
      const storedData = getFromStorage(LocalStorageKeys.CONFIG);
      setData(storedData?.tables || []);
      setFilteredData(storedData?.tables || []); // Initialize filteredData with the fetched data
    };

    fetchData();
  }, []);

  const handleTableSearch = useCallback(
    debounce((searchTerm) => {
      const lowerCaseSearchTerm = searchTerm.toLowerCase();
      const filtered = data.filter((item) =>
        item.tableName.toLowerCase().includes(lowerCaseSearchTerm)
      );
      setFilteredData(filtered);
    }, 500), // 0.5 seconds debounce delay
    [data]
  );

  const onSelectData = (data) => {
    // console.log("data", data);
    setselectedData(data);
  };

  const handleUseTable = () => {
    console.log("ssss", selectedData);
    dispatch(setObjectDetails({ ...selectedData }));
    navigate("/app-tabs-items-component/loadtable");
  };

  return (
    <div className="ng-star-inserted">
      <div className="tab-pane custom-tabPane2">
        <div className="cnt-space">
          <div className="leftside">
            <fieldset className="less-space">
              <legend>Saved Templates</legend>
              <br />
              <div>
                <input
                  className="form-control"
                  placeholder="Search templates"
                  type="text"
                  onChange={(e) => handleTableSearch(e.target.value)}
                />
                <DataTable
                  title={""}
                  columns={columnDefination}
                  data={filteredData}
                  onSelectRow={onSelectData}
                />
              </div>
            </fieldset>
          </div>
          <div className="rightside text-right right-action">
            <button
              className="btn btn-primary active"
              type="button"
              onClick={handleUseTable}
              disabled={!selectedData}
            >
              Use
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SaveTable;
